import { controller, controllerAs, template } from 'modals/marketplaceRegister';

import './style.less';
import { get } from 'lodash';

/* @ngInject */
export default function(
  $scope,
  $log,
  $stateParams,
  $uibModal,
  $uibModalStack,
  ApiClass,
  ProfileClass,
  AuthClass,
  VendorClass,
  Swal
) {
  $scope.bundleId = $stateParams.id;

  const loggedIn = ProfileClass.loggedIn;

  const num = getRandomInt(0, 40);
  $scope.stockImage = `https://assets.prolaera.com/img/stock-images/stock-image-${num}.jpg`;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  $scope.purchase = bundle => {
    if (bundle.status === 'registered') return;

    const vendor_id = get(bundle, 'vendor.vendor_id', bundle.vendor_id);

    if (!loggedIn) return AuthClass.authenticationPopup({ company_id: VendorClass.convertUser(vendor_id) }); //open login for not logged in users;

    $uibModalStack.dismissAll();

    $uibModal
      .open({
        backdrop: true,
        size: 'lg',
        template,
        controller,
        controllerAs,
        resolve: {
          event: () => false,
          bundle: () => bundle,
          adminRegistration: () => false,
          profileData: () => undefined,
          manage: () => false,
          loadContent: () => true
        }
      })
      .result.then(status => {
        if (status === 'registered') Swal.toast('Bundle purchased successful!');
        $scope.bundle.status = 'registered';
      });
  };

  function activate() {
    ApiClass.productsIdPost(
      { id: $scope.bundleId },
      {
        projection: ['author', 'description', 'price', 'priceText', 'productName', 'status', 'vendor_id', 'pass']
      },
      {}
    )
      .then(({ data }) => {
        $scope.bundle = data.product;
        $scope.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        $scope.loaded = true;
        $scope.error = { status: error.status, refresh: activate };
        throw error;
      });
  }

  activate(); // TODO convert to controllerAs
}



// WEBPACK FOOTER //
// ./src/app/controllers/marketplace/bundle/controller.js